export class DataChar {
  public data: any[];
  public label: string;
}
